export default {"src":"/_next/static/media/cart-icon.9accb288.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};